import {
  DELETE_FILTER_FUEL,
  FuelFilterStateProps,
  SET_FILTER_FUEL,
} from '@/store/redux/actions/pages/pcp';
import {
  deleteFromFilterArrayHandler,
  IReduxActionProps,
} from '@/store/redux/Utils';

import { RESET_FILTER_FUEL } from './../../../../../actions/pages/pcp/filters/fuel/index';

export const InitialFuelFilterState: FuelFilterStateProps = {
  fuelType: [],
  maxFuelConsumption: null,
  maxPowerConsumption: null,
};

const FuelFilterState = (
  state: FuelFilterStateProps = InitialFuelFilterState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_FILTER_FUEL: {
      const value = action.payload as FuelFilterStateProps;

      return {
        ...state,
        ...value,
      };
    }
    case DELETE_FILTER_FUEL: {
      const payloadKey = action.payload && Object.keys(action.payload)[0];

      // consumption case
      if (
        payloadKey === 'maxFuelConsumption' ||
        payloadKey === 'maxPowerConsumption'
      ) {
        return {
          ...state,
          [payloadKey]: null,
        };
      }

      // fuelType case
      return (
        action.payload && deleteFromFilterArrayHandler(state, action.payload)
      );
    }
    case RESET_FILTER_FUEL:
      return InitialFuelFilterState;
    default:
      return state;
  }
};

export default FuelFilterState;
